import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref, watch } from 'vue';
import { CountUp, CountUpOptions } from 'countup.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnimatedNumber',
  props: {
    number: { default: 0 },
    duration: { default: 2000 }
  },
  setup(__props: any) {

const props = __props as { number: number, duration: number }



const initialNumber = ref(0);
const counter = ref<HTMLElement>(null);
const countUp = ref<CountUp>(null);

const options = computed<CountUpOptions>(() => {
    return {
        duration: props.duration / 1000,
        startVal: props.number,
        useEasing: true,
        separator: '',
        easingFn: (t, b, c, d) => {
            const x = t / d;
            return x === 0
                ? 0
                : x === 1
                ? 1
                : x < 0.5
                ? (c * Math.pow(2, 20 * x - 10)) / 2 + b
                : (c * (2 - Math.pow(2, -20 * x + 10))) / 2 + b;
        }
    };
});

onMounted(() => {
    initialNumber.value = props.number;
    // eslint-disable-next-line no-new
    countUp.value = new CountUp(counter.value, props.number, options.value);
    countUp.value.start();
});

watch(
    () => props.number,
    () => {
        countUp.value.update(props.number);
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    ref_key: "counter",
    ref: counter
  }, null, 512))
}
}

})